import { css, html, LitElement } from 'lit-element';
import { pxToRem } from 'lm-ui-kit/src/utils/css-utils';

export const props = {
  subtitle: { type: String },
};

export class UcFormSubtitle extends LitElement {
  static get properties() {
    return props;
  }

  static styles = css`
    :host {
      display: block;
    }

    .subtitle {
      width: 100%;
      margin: 0;
      text-align: left;
      color: #333333;
      font-weight: 400;
      font-size: ${pxToRem(16)};
      line-height: ${pxToRem(20)};
    }

    .subtitle-content {
      display: inline;
    }
  `;

  render() {
    return html`
      <p class="subtitle">
        <slot class="subtitle-content">${this.subtitle}</slot>
      </p>
    `;
  }
}
